import lazyLoadView from "@router-utils/lazyload-view";
import routerPrepaid from "@router/route-prepaid";
import routerReservation from "@router/route-reservation";
import routerPage from "@router/route-page";
import routerMember from "@router/route-member";
import routeCheckout from "@router/route-checkout";
import routeLogin from "@router/route-login";
import routeComment from "@router/route-comment";
import routeStore from "@router/route-store";
import routeSpa from "@router/route-spa";
import routeReception from "@router/route-reception";
import routeMemberWordpress from "@router/route-member-wordpress"
import routeLoginWordpress from "@router/route-login-wordpress"
import routeDeposit from "@router/route-deposit";
import routelevel from "@router/route-level";
import routeCart from "@router/route-cart";

export default [
  ...routeLogin,
  ...routerPage,
  ...routerMember,
  ...routerPrepaid,
  ...routerReservation,
  ...routeCheckout,
  ...routeComment,
  ...routeStore,
  ...routeSpa,
  ...routeReception,
  ...routeMemberWordpress,
  ...routeLoginWordpress,
  ...routeDeposit,
  ...routelevel,
  ...routeCart,

  // 404
  {
    path: '/404',
    name: '404',
    component: require('@src/views/_404').default,
    props: true,
  },
  // Style Guide
  {
    path: '/style-guide',
    name: 'style-guide',
    component: () => lazyLoadView(import('@src/views/StyleGuide/Index')),
    meta: {
      isDevelopmentPage: true
    }
  },
  {
    path: '*',
    redirect: '404',
  },
]
